import { createRouter } from "../../util/search";
import routes from "./routes";


export default createRouter({
    base: '/plateaux',
    routes,
});
